// src/pages/expense/service/ExpenseServiceDraftList.jsx
// ✅ 전 사업 확산 [4] — 용역사업 "지출목록" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftList.jsx(공통 컴포넌트)에 있고, 이 파일은
// 용역사업 전용 config(serviceDraftConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftList from "../_shared/ExpenseDraftList";
import serviceDraftConfig from "./serviceDraftConfig";

export default function ExpenseServiceDraftList() {
  return <ExpenseDraftList config={serviceDraftConfig} />;
}
